import {createApp} from 'vue'
import CreateEvent from './CreateEvent'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const el = '.kb-component--create-event'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CreateEventDOM)=>{
            const props = handleComponentProps(CreateEvent, CreateEventDOM)
            const component = createApp(CreateEvent, props).use(Store)
            component.mount(CreateEventDOM)
        })
    }
}